<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer mr-4">
    <span class="cursor-pointer flex items-center i18n-locale px-2 py-1 rounded hover:bg-gray-100">
      <span class="text-lg leading-none">{{ getCurrentLocaleData.flag }}</span>
      <span class="hidden sm:block ml-2 font-medium text-sm">{{ getCurrentLocaleData.lang }}</span>
      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1" />
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item 
        @click="updateLocale('en')" 
        :class="{ 'bg-primary-light': $i18n.locale === 'en' }"
        class="flex items-center py-2"
      >
        <span class="text-lg leading-none">🇺🇸</span>
        <span class="ml-3">English</span>
        <feather-icon v-if="$i18n.locale === 'en'" icon="CheckIcon" svgClasses="h-4 w-4 ml-auto text-primary" />
      </vs-dropdown-item>
      <vs-dropdown-item 
        @click="updateLocale('zh')" 
        :class="{ 'bg-primary-light': $i18n.locale === 'zh' }"
        class="flex items-center py-2"
      >
        <span class="text-lg leading-none">🇨🇳</span>
        <span class="ml-3">简体中文</span>
        <feather-icon v-if="$i18n.locale === 'zh'" icon="CheckIcon" svgClasses="h-4 w-4 ml-auto text-primary" />
      </vs-dropdown-item>
      <vs-dropdown-item 
        @click="updateLocale('ms')" 
        :class="{ 'bg-primary-light': $i18n.locale === 'ms' }"
        class="flex items-center py-2"
      >
        <span class="text-lg leading-none">🇲🇾</span>
        <span class="ml-3">Bahasa Melayu</span>
        <feather-icon v-if="$i18n.locale === 'ms'" icon="CheckIcon" svgClasses="h-4 w-4 ml-auto text-primary" />
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import { setLocale } from '@/i18n/i18n'

export default {
  computed: {
    getCurrentLocaleData () {
      const locale = this.$i18n.locale
      if (locale === 'en') return { flag: '🇺🇸', lang: 'English' }
      else if (locale === 'zh') return { flag: '🇨🇳', lang: '简体中文' }
      else if (locale === 'ms') return { flag: '🇲🇾', lang: 'Bahasa Melayu' }
      return { flag: '🇺🇸', lang: 'English' }
    }
  },
  methods: {
    updateLocale (locale) {
      setLocale(locale)
    }
  }
}
</script>
